@switch (type()) {
@case ('VIDEO') {
<span class="d-flex align-center text-blue">
  <ui5-icon class="icon udex-me-16 text-blue" name="play" aria-hidden="true"></ui5-icon>
  {{ 'productDetails.watchVideo' | cxTranslate }}
</span>
}
@case ('PDF') {
<span class="d-flex align-center text-blue"
  (click)="onPdfClick()">
  <ui5-icon class="icon udex-me-16 text-blue" name="pdf-attachment" aria-hidden="true"></ui5-icon>
  {{ 'productDetails.readPdf' | cxTranslate }}
</span>
}
@case ('LINK') {
<span class="d-flex align-center text-blue">
  <ui5-icon class="icon udex-me-16 text-blue" name="world" aria-hidden="true"></ui5-icon>
  {{ 'productDetails.visitWebsite' | cxTranslate }}
</span>
}
}
